
































































































import { Component, Vue, Ref, Prop, PropSync, Watch } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
//  types
import { ExtendedVessel } from "@/types/vessel";
import { MapMarker } from "@/types/mapMarker";
import { TempPoint } from "@/types/TempPoint";
//  components
import Map from "@/components/Map.vue";
import DateRangeEventsDatepicker from "@/components/diagnostics/DateRangeEventsDatepicker.vue";
//  modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import DiagnosticsModule from "@/store/clients/Diagnostics.module";

const Diagnostics = getModule(DiagnosticsModule, store);
const Vessels = getModule(VesselsModule, store);

@Component({
  components: {
    Map,
    DateRangeEventsDatepicker,
  },
})
export default class OperationalProfileCard extends Vue {
  @Ref("Map") Map!: any;
  @Prop({ default: false }) isModal!: boolean;
  @PropSync("dateRange", { required: true }) syncDateRange!: string[];

  syncSpeedLog = false;
  isFromDateModalActive = false;
  isToDateModalActive = false;
  invalidRange = false;
  currentDate: string = moment.utc().format("YYYY-MM-DD");
  fromDate: string = moment.utc().startOf("year").format("YYYY-MM-DD");
  toDate: string = moment.utc().format("YYYY-MM-DD");
  min = moment.utc(moment.utc().year(this.speedHistoryStartYear).startOf("year").format("YYYY-MM-DD")).valueOf();
  max = moment.utc(moment.utc().format("YYYY-MM-DD")).valueOf();
  interval: any = moment.duration(1, "days").asMilliseconds();
  seaTemperatureDateRange!: { from: string; to: string };

  @Watch("syncDateRange", { deep: true })
  onSeaTemperatureDateRangeChanged(): void {
    this.seaTemperatureDateRange = { from: this.syncDateRange[0], to: this.syncDateRange[1] };
    this.fromDate = moment.utc(this.seaTemperatureDateRange.from).format("YYYY-MM-DD");
    this.toDate = moment.utc(this.seaTemperatureDateRange.to).format("YYYY-MM-DD");
  }
  // @Getters
  get periodDateRange(): [string, string] {
    return [this.fromDate, this.toDate];
  }
  set periodDateRange(val: [string, string]) {
    this.fromDate = val[0];
    this.toDate = val[1];
  }

  get themeClass(): string {
    return this.$vuetify.theme.dark ? "theme--dark" : "theme--light";
  }

  get vessel(): ExtendedVessel | null {
    return Vessels.currentVessel;
  }

  get getSeaTemperatureDateRange(): { from: string; to: string } {
    return this.seaTemperatureDateRange;
  }

  get getSeaTemperaturePoints(): TempPoint[] {
    return Diagnostics.seaSurfaceTemperature;
  }

  get hoursInWarmWater(): string {
    if (!this.getSeaTemperaturePoints.length) return "N/A";

    var total = 0;
    this.getSeaTemperaturePoints.forEach((point, i) => {
      if (point.temperature >= 25 && point.timeSpent) {
        total += point.timeSpent;
      }
    });

    return `${Math.round(total)} hours`;
  }

  get speedHistoryStartYear(): number {
    return Number(moment.utc(Diagnostics.speedHistoryStartYear).format("YYYY"));
  }

  get formattedSelectedDateRange(): { from: string; to: string } {
    return {
      from: moment.utc(this.syncDateRange[0]).format("DD. MMM, YYYY"),
      to: moment.utc(this.syncDateRange[1]).format("DD. MMM, YYYY"),
    };
  }

  get mapHeight(): string {
    return this.isModal ? "height: 708px;" : "height: 544px";
  }

  get isUsingDerivedStw(): boolean {
    return Diagnostics.diagnosticsChartConfig.useDerivedStw;
  }

  // @Methods
  onPeriodDateRangeChange([from, to]: [string, string]) {
    this.fromDate = from;
    this.toDate = to;
    this.syncDateRange = [from, to];
    this.seaTemperatureDateRange = { from, to };

    // Validate range
    const fromDate = moment.utc(from);
    const toDate = moment.utc(to);
    const rangeYears = toDate.diff(fromDate, "years", true);
    this.invalidRange = rangeYears > 5;

    // Update diagnostics config and map if valid
    if (!this.invalidRange) {
      const config = Diagnostics.diagnosticsChartConfig;
      config.opFromDate = from;
      config.opToDate = to;
      Diagnostics.updateDiagnosticsChartConfig(config);
      this.Map.updateWeatherData(this.seaTemperatureDateRange);
    }
  }

  onMarkerClicked(marker: MapMarker): void {
    if (this.syncSpeedLog) {
      this.$emit("markerClicked", marker);
      this.Map.map.fitBounds([[marker.position.lat, marker.position.lng]]);
    }
  }

  onTrackClicked(marker: MapMarker): void {
    if (this.syncSpeedLog) this.$emit("trackClicked", { trackDateStart: marker.trackHistory.prevMarkers.slice(-1)[0].lastExportDate, trackDateEnd: marker.trackHistory.prevMarkers[0].lastExportDate });
  }

  onMapZoom(minMaxDateRange: { min: number; max: number; zoomedOut: boolean }): void {
    if (this.syncSpeedLog) this.$emit("onOperationalProfileZoom", minMaxDateRange);
  }

  setDateRange(datesRange: { min: number; max: number }): void {
    this.fromDate = moment.utc(datesRange.min).format("YYYY-MM-DD");
    this.toDate = moment.utc(datesRange.max).format("YYYY-MM-DD");
    this.syncDateRange = [this.fromDate, this.toDate];
    Vue.set(this.seaTemperatureDateRange, "from", moment.utc(this.fromDate).format("YYYY-MM-DD"));
    Vue.set(this.seaTemperatureDateRange, "to", moment.utc(this.toDate).format("YYYY-MM-DD"));

    this.Map.$refs.mapRef.setZoom(1);
    this.Map.updateWeatherData(this.seaTemperatureDateRange);
  }

  created(): void {
    this.seaTemperatureDateRange = { from: this.syncDateRange[0], to: this.syncDateRange[1] };
    this.fromDate = moment.utc(this.seaTemperatureDateRange.from).format("YYYY-MM-DD");
    this.toDate = moment.utc(this.seaTemperatureDateRange.to).format("YYYY-MM-DD");
  }
}
